export default __webpack_public_path__ + "static/media/ribbon3.26c42a46.svg";